import DirectoryIcon from './Directory';
import DistrictsIcon from './Districts';
import EventsIcon from './Events';
import HomeIcon from './Home';
import MagazineIcon from './Magazine';

const MenuIcons = {
    home: HomeIcon,
    magazine: MagazineIcon,
    events: EventsIcon,
    districts: DistrictsIcon,
    directory: DirectoryIcon,
};

export type MenuIconKey = keyof typeof MenuIcons;

export default MenuIcons;
